<template>
  <div class="pagination">
    <div class="pagination__total">{{ totalItem }} item</div>

    <div class="pagination__container">
      <router-link
        class="pagination__prev-page first"
        v-if="page !== 1"
        :to="getUrl.replace(':page', 1) + queryParams"
      >
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="20px"
            height="20px"
            viewBox="0 -0.5 17 17"
            version="1.1"
            class="si-glyph si-glyph-two-arrow-left"
          >
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g transform="translate(1.000000, 3.000000)" fill="#fff">
                <path
                  d="M4.146,5.027 L7.89,0.032 L3.95,0.032 L0.007,5.027 L4.049,9.991 L7.967,9.991 L7.977,9.98 L4.146,5.027 Z"
                  class="si-glyph-fill"
                ></path>
                <path
                  d="M11.929,5.027 L15.88,0.032 L11.941,0.032 L7.976,5.027 L12.04,9.991 L15.958,9.991 L15.968,9.98 L11.929,5.027 Z"
                  class="si-glyph-fill"
                ></path>
              </g>
            </g>
          </svg>
        </div>
      </router-link>
      <router-link
        class="pagination__prev-page"
        v-if="page !== 1"
        :to="getUrl.replace(':page', page - 1) + queryParams"
      >
        <div></div>
      </router-link>
      <router-link
        v-for="currentPage in pages"
        :key="currentPage"
        :class="[
          'pagination__item',
          currentPage === page && 'active',
          currentPage === null && 'null',
        ]"
        :to="getUrl.replace(':page', currentPage) + queryParams"
      >
        {{ currentPage }}
      </router-link>
      <router-link
        class="pagination__next-page"
        v-if="page !== maxPage"
        :to="getUrl.replace(':page', page + 1) + queryParams"
      >
        <div></div>
      </router-link>
    </div>
    <div class="pagination__count">
      {{ page }} of
      <router-link class="pagination__last" :to="getUrl.replace(':page', maxPage) + queryParams">{{
        maxPage
      }}</router-link>
    </div>
  </div>
</template>

<script>
import ROUTE from "~/constants/routes";

export default {
  name: "Pagination",
  props: {
    maxPage: {
      type: [Number, String],
      default: 0,
    },
    page: {
      type: [Number, String],
      default: 0,
    },
    totalItem: {
      type: [Number, String],
      default: 0,
    },
    urlList: {
      type: String,
      default: "",
    },
    teamId: {
      type: String,
      default: null,
    },
    queryParams: {
      type: String,
      default: "",
    },
  },
  computed: {
    pages() {
      if (this.maxPage == 1) {
        return [1];
      } else {
        const pagesArray = [
          this.page != 2 && this.page != 1 ? this.page - 2 : null,
          this.page != 1 ? this.page - 1 : null,
          this.page,
          this.page != this.maxPage ? this.page + 1 : null,
          this.page != this.maxPage - 1 && this.page != this.maxPage ? this.page + 2 : null,
        ];
        return pagesArray;
      }
    },
    getUrl() {
      if (this.teamId != null) {
        return ROUTE[this.urlList].replace(":id", this.teamId);
      } else {
        return ROUTE[this.urlList];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px 0;

  &__total {
    padding-right: 20px;
  }

  &__count {
    padding-left: 20px;
  }

  &__container {
    display: flex;
    align-items: center;
  }

  &__item {
    font-size: 14px;
    margin: 0 10px;
    cursor: pointer;
    color: $mainColor;
  }

  &__item.null {
    margin: 0;
  }

  &__last {
    color: $coffee;
  }

  &__item.active {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 1px;
    background: $coffee;
    font-size: 14px;
    color: #fff;
    pointer-events: none;
  }

  &__prev-page {
    display: inline-block;
    background: $coffee;
    opacity: 0.85;
    border-radius: 1px;
    width: 30px;
    height: 30px;
    margin-right: 10px;
    cursor: pointer;
    &:hover {
      background: $coffee;
      opacity: 0.7;
    }
    &.first {
      div {
        background: none;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
      }
    }
    div {
      background-image: url("../../assets/images/icons/slick-prev.png");
      height: 30px;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  &__next-page {
    display: inline-block;
    background: $coffee;
    opacity: 0.85;
    border-radius: 1px;
    width: 30px;
    height: 30px;
    margin-left: 10px;
    cursor: pointer;
    &:hover {
      background: $coffee;
      opacity: 0.7;
    }
    div {
      background-image: url("../../assets/images/icons/slick-next.png");
      height: 30px;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
}
</style>
